<template>

  <e-charts
    ref="lineChart"
    autoresize
    :options="line"
    theme="theme-color"
    auto-resize
    @mousemove="$emit('mousemove', $event)"
    @click="$emit('click', $event)"
  />
  <!-- echart -->

</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/line'
import theme from '@core/components/charts/echart/theme.json'

ECharts.registerTheme('theme-color', theme)
export default {
  name: 'GraficosCustom',
  components: {
    ECharts,
  },
  props: ['dataChart', 'labelChart'],
  data() {
    return {
      line: {
        visualMap: [{
          type: 'piecewise',
        }],
        grid: {
          width: '94.4%',
          height: '96%',
          left: '29px',
          top: '6x',
          lineColor: 'red',
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            params = params[0]
            return (
              ` <span style="font-size: 1.5rem">Tempo:${params.axisValue}<br/>${params.seriesName}: ${params.data}</span>`
            )
          },
        },
        xAxis: [{
          show: true,
          boundaryGap: false,
          data: this.dataChart,
        }],
        yAxis: {
          type: 'value',
        },
        series: {
          name: 'Audiência',
          type: 'line',
          showSymbol: false,
          smooth: true,

          areaStyle: {
            color: '#fd03039e',
            border: 'red',
            opacity: 0.5,
            fontSize: 18,

          },
          data: this.labelChart,
        },
      },
    }
  },
  methods: {
    updatedChart(dataChart, labelSeries) {
      this.line.series.data = dataChart
      this.line.xAxis[0].data = labelSeries
      this.$refs.lineChart.init(this.line)
      this.$refs.lineChart.refresh()
    },
  },
}
</script>
